module.exports = __webpack_public_path__ + "5c2666942378800eb4abd45f06704540.svg";